/** The three ways a thing can be shared (household sharing D1/D2). */
export const VISIBILITY_LABELS = {
  private: "Private",
  household: "Household",
  people: "Specific people",
};
